import useTranslation from "@/hooks/useTranslation";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  useMediaQuery,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Spin } from "antd";
import React, { useState } from "react";

interface IFormProps {
  name: string;
  description: string;
  public: boolean;
}

interface IProps {
  open: boolean;
  term: string;
  id: string;
  loading: boolean;
  handleClose: () => void;
  handleSubmit: (props: {
    id: string;
    description: string;
    public: boolean;
    name: string;
  }) => Promise<void>;
}

const AddSubDialog: React.FC<IProps> = ({
  open,
  term,
  id,
  loading,
  handleClose,
  handleSubmit,
}) => {
  const { t } = useTranslation("bundle");
  const matches = useMediaQuery("(max-width:600px)");

  const [formProps, _setFormProps] = useState<IFormProps>({
    name: "",
    description: "",
    public: true,
  });

  const setFormProps = (value: Partial<IFormProps>) =>
    _setFormProps((prev) => ({ ...prev, ...value }));

  return (
    <Dialog open={open} onClose={handleClose} fullScreen={matches}>
      <Spin spinning={loading}>
        <DialogTitle>{t("sub.add.about-topic", { term })}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <TextField
              multiline
              error={formProps.name.length > 32}
              helperText={
                formProps.name.length > 32 && t("sub.add.name-length")
              }
              autoFocus
              required
              margin="dense"
              id="name"
              label={t("sub.add.name")}
              type="text"
              fullWidth
              value={formProps.name}
              onChange={(e) => setFormProps({ name: e.target.value })}
            />
            <TextField
              required
              multiline
              error={formProps.description.length > 3000}
              helperText={
                formProps.description.length > 3000 &&
                t("sub.add.description-length")
              }
              margin="dense"
              id="description"
              label={t("sub.add.description")}
              type="text"
              fullWidth
              value={formProps.description}
              onChange={(e) => setFormProps({ description: e.target.value })}
            />
            <FormControl component="fieldset" required>
              <RadioGroup
                name="privacy"
                value={formProps.public.toString()}
                onChange={(e) => {
                  setFormProps({
                    public: e.target.value === "true" ? true : false,
                  });
                }}
                row
              >
                <FormControlLabel
                  value="true"
                  control={<Radio color="primary" />}
                  label={t("sub.add.privacy.public")}
                />
                <FormControlLabel
                  value="false"
                  control={<Radio color="primary" />}
                  label={t("sub.add.privacy.private")}
                />
              </RadioGroup>
            </FormControl>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t("common:cancel")}</Button>
          <Button
            onClick={() => handleSubmit({ ...formProps, id })}
            color="primary"
            autoFocus
          >
            {t("common:submit")}
          </Button>
        </DialogActions>
      </Spin>
    </Dialog>
  );
};

export default AddSubDialog;
